<template><div><h1 id="corris-import" tabindex="-1"><a class="header-anchor" href="#corris-import"><span>Corris-Import</span></a></h1>
<p>Corris-Import — Import Mitgliederdaten von Corris</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dieser Job importiert Adress- und Mitgliederdaten in die funtrade-Datenbank. Dabei werden neue Zusagen, Adressen mit Telekommunikationsdaten, Behandlungsdaten (je nach Parametrisierung resultieren daraus Merkmale Ereignisse oder Publikationen) angelegt.</p>
<p>Der Import kann mit verschiedenen Optionen und Varianten ausgeführt werden. Diese werden über Systemparameter definiert. Die wichtigtsen Parameter sind &quot;corrisZahlung&quot; (definiert, ob für die Gutschriften Buchungen erfasst werden) und &quot;CorrisImpVariante&quot; (definiert, ob das Quellfile alle Daten enthält oder nur jeweils die neusten, noch nicht importierten). Die Einstellungen für die einzelnen Zusagen sind in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.corrisparametrisierung.html" title="Corris-Import: Parametrisierung">Zusagen-Import Parametrisierung</RouteLink> definiert.</p>
<p>Von Corris werden diese Files angeliefert:</p>
<table>
<thead>
<tr>
<th>File</th>
<th>optional</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adressen</td>
<td>nein</td>
<td>Adress- und Telekommunikationsdaten. Es werden jeweils nur die neuen Adressen übernommen, keine Adressänderungen. Bei Adressen, die bereits in funtrade vorhandn sind, wird nur ein Link in der Tabelle Personenlinks Corris-funtrade angelegt (Test mit gleichen Algorithmen wie bei der Dublettensuche).</td>
</tr>
<tr>
<td>Behandlungen</td>
<td>ja</td>
<td>Behandlungen werden gemäss der Tabelle &quot;Behandlungscodes Parametrisierung&quot; in Merkmale/Ereignisse/Publikationen (&quot;MEP&quot;) &quot;übersetzt&quot;. Die Daten von Corris werden &quot;gespiegelt&quot;. D. h. wenn ein Behandlungscode nicht mehr geliefert wird, bwirkt das die Löschung der erfassten &quot;MEP&quot;. Deshalb dürfen die gleichen &quot;MEP&quot; nicht manuell erfasst oder gelöscht werden. Das Löschen dieser Daten durch den Importprozess kann unterbunden werden, wenn in der Stammtabelle der Behandlungscodes des Feld &quot;Import Werte&quot; auf &quot;einmalig&quot; gesetzt ist (z.B. bei einer einmaligen Datenlieferung von Corris).</td>
</tr>
<tr>
<td>Mitglieder</td>
<td>nein</td>
<td>Enthält die Zusagendaten. Es wird immer der vollständige Datenbestand geliefert. Beim Import legt funtrde neue Zusagen an oder erfasst Austritte mit Austrittsereignissen gem. Tabelle &quot;Stornogründe Parametrisierung&quot;</td>
</tr>
<tr>
<td>Debitoren</td>
<td>nein</td>
<td>Dieses File enthält Gutschriften und Stornos. Die Gutschriften werden als Ereignisse abgebildet und je nach Parametrisierung werden auch Buchungen angelegt. Die entsprechenden Ereignisse sind in der Tabelle Zusagen Import-Parametrisierung definiert. Bei Lastschriften/Widerrufen wird das Zahlungsereignis gelöscht und ein Widerrufsereignis gesetzt (gem. Definition in der Tabelle Zusagen Import-Parametrisierung. In diesem File werden auch Daten zu Kreditkarten-Transaktionen mitgeliefert, die in das Infofeld der Manuellen (Zahlungs-)Buchung eingetragen werden..</td>
</tr>
<tr>
<td>Konten</td>
<td>ja</td>
<td>Es werden nur Kontodaten von aktiven Zusagen importiert. Kontodaten werden in der Regel erst bei einer definitiven Datenübergabe geliefert.</td>
</tr>
<tr>
<td>Kontakte</td>
<td>ja</td>
<td>Enthält Resultate aus Kontakten von Corris, meist aus Call Center Aktionen. Die Kontakte werden gemäss der Tabelle &quot;Kontakte Parametrisierung&quot; in Merkmale, Ereignisse oder Publikationen &quot;übersetzt&quot;.</td>
</tr>
<tr>
<td>Korrespondenz</td>
<td>ja</td>
<td>Löst &quot;hardcodierte&quot; Aktionen (wie Zahlungsartanpassungen, Aufgaben usw.) aus. Ist spezifisch, nach Kundenanforderung, programmiert worden.</td>
</tr>
<tr>
<td>Spenden</td>
<td>ja</td>
<td>Die Spendedaten werden in ein .csv-FIle übernommen, das zusammen mit den importierten Daten auf dem Server abgelegt wird (... unter /u/[Kürzel]/tm/daten/corris/...)</td>
</tr>
</tbody>
</table>
<p>Die Daten werden immer als sog. &quot;Dataset&quot; (mehrere zusammengehörige Textfiles) geliefert:</p>
<p>Der Filename ist wie folgt aufgebaut:</p>
<p>XXX_Datentyp_JJJJMMTT.txt</p>
<p>XXX = Mandant (z.B. &quot;&quot;WWF&quot;)</p>
<p>Name = Name (z.B. Adressen)</p>
<p>Datum = Jahr, Monat, Tag</p>
<p>.txt = File-Endung</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Datenaustausch → Verarbeitungsläufe → Corris-Schnittstelle → Daten von Corris importieren</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Importdateien</dt>
<dd>Upload der Dateien. Es müssen alle Dateien zusammen selektiert und hochgeladen werden.</dd>
<dt>Importoptionen</dt>
<dd>Testlauf (erstellt ein Protokoll, ohne Daten zu verändern) oder verarbeiten (startet den Import).</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Es wird ein Protokoll erstellt, worin folgendes festgehalten ist:</p>
<table>
<thead>
<tr>
<th>File</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Datum</td>
<td>Datum, Zeit, User-ID</td>
</tr>
<tr>
<td>Modus</td>
<td>TEST (Testlauf) oder MAKE (Import)</td>
</tr>
<tr>
<td>Pfad</td>
<td>Pfad zum Verzeichnis mit den Importfiles</td>
</tr>
<tr>
<td>Daten</td>
<td>Auflistung der importierten Files</td>
</tr>
<tr>
<td>...daten</td>
<td>Auflistung von Daten, die manuell nachbearbeitet werden sollen oder nicht importiert worden sind.</td>
</tr>
</tbody>
</table>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Datenfiles, geliefert von Corris</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Siehe oben unter &quot;Beschreibung&quot;.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.corrislink.html" title="Corris-Import: Linktabelle">Personenlinks Corris-funtrade</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.corrisparametrisierung.html" title="Corris-Import: Parametrisierung">Zusagen-Import Parametrisierung</RouteLink></p>
</div></template>


